export default __webpack_public_path__ + "static/badge-locked-5854c418eca8338ec89f5a26bca4f520.png";